import React, { useContext } from 'react';
import * as Icons from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { AppHeaderPortal } from '@modules/layout/components/header-portal';
import { StyledActionBar } from '@shared/styled/action-bar';
import { useSelection } from '@shared/modules/next-table/hooks/use-selection';
import { BasketTableContext } from '../contexts/table';
import { StyledHeaderButton } from '@modules/layout/styled/header';
import { useBackgroundNavigate } from '@shared/hooks';
import { Space } from 'antd';



export const BasketTableActions = () => {
  const { state, handleSelectAll, handleResetSelection, handleFetch, handleReset } = useContext(BasketTableContext);
  const selection = useSelection(state.selectedRowIds);
  const { t } = useTranslation();
  const navigate = useBackgroundNavigate()

  const goTo = (type: string, withBackground = false) => {
    navigate(`/baskets/${type}`, { withBackground })
  }

  return (
    <AppHeaderPortal>
      {!!selection.length && (
        <StyledActionBar $visible={!!selection.length} $flex={true}>
          <StyledActionBar.Selection>
            <Icons.CloseCircleTwoTone role='icon' onClick={handleResetSelection} />
            <span>{selection.length} sətir seçilib</span>
          </StyledActionBar.Selection>
        </StyledActionBar>
      )}
      {!selection.length && (
        <StyledActionBar $visible={!selection.length} $flex={true}>
          <Space>
            <StyledHeaderButton onClick={() => goTo("create", true)} $ghost={true} icon={<Icons.PlusCircleOutlined />}>
              {t('common.actions.create')}
            </StyledHeaderButton>
            <StyledHeaderButton $ghost={true} onClick={handleSelectAll} icon={<Icons.CheckCircleOutlined />}>
              {t('common.actions.selectAll')}
            </StyledHeaderButton>
            <StyledHeaderButton $ghost={true} onClick={handleFetch} icon={<Icons.ReloadOutlined />}>
              {t('common.actions.reload')}
            </StyledHeaderButton>
            <StyledHeaderButton $ghost={true} onClick={handleReset} icon={<Icons.ClearOutlined />}>
              {t('common.actions.reset')}
            </StyledHeaderButton>
          </Space>
          <Space>
            <StyledHeaderButton $ghost={true} onClick={() => goTo("transfer")} icon={<Icons.SwapOutlined />}>
              {t('baskets.transfer')}
            </StyledHeaderButton>
          </Space>
        </StyledActionBar>
      )}
    </AppHeaderPortal>
  );
};
